import React, { useMemo, useState } from 'react';
import { Search } from 'lucide-react';
import { AddTrackRow } from './TrackRows';

export const filterPlaylistTracks = (tracks, query) => {
  const normalizedQuery = query.trim().toLocaleLowerCase();
  if (!normalizedQuery) return tracks;

  return tracks.filter(track => [track?.name, track?.artist, track?.album]
    .some(value => String(value || '').toLocaleLowerCase().includes(normalizedQuery)));
};

export function PlaylistTracks({ tracks = [], error = '', onAdd, formatDuration }) {
  const [query, setQuery] = useState('');
  const filteredTracks = useMemo(() => filterPlaylistTracks(tracks, query), [tracks, query]);
  const hasQuery = Boolean(query.trim());

  return (
    <>
      <div className="search-container playlist-search-container">
        <input
          type="search"
          className="search-input playlist-search-input"
          placeholder="Search within playlist..."
          aria-label="Search within playlist"
          value={query}
          onChange={event => setQuery(event.target.value)}
        />
        <Search className="search-icon" size={40} aria-hidden="true" />
      </div>

      <div className="results-container">
        {error && (
          <div className="playlist-error-state">
            <h2>Playlist unavailable</h2>
            <p>{error}</p>
          </div>
        )}
        {!error && filteredTracks.map((track, index) => (
          <AddTrackRow
            key={`${track.id || track.uri}-${index}`}
            track={track}
            index={index}
            onAdd={onAdd}
            formatDuration={formatDuration}
          />
        ))}
        {!error && hasQuery && filteredTracks.length === 0 && (
          <div className="playlist-no-results" role="status">No songs found in this playlist.</div>
        )}
      </div>
    </>
  );
}
